import { exportAsExcel } from "src/DigitalProtocolModule/utils/ajax-proxy";
import { message } from "antd";
import DOMPurify from "dompurify";

export interface IProtocolVersion {
  title: string;
  description: string;
}

export interface MenuItem {
  label: string;
  key: string;
}

export const statusOption: MenuItem[] = [
  {
    label: "Not Started",
    key: "Not Started",
  },
  {
    label: "In Progress",
    key: "In Progress",
  },
  {
    label: "Completed",
    key: "Completed",
  },
];

export const protocolVersionData: IProtocolVersion[] = [
  {
    title: "Original",
    description: "Version Description",
  },
  {
    title: "Amendment 1",
    description: "Version Description",
  },
];

function isValidUrl(url) {
  try {
    const parsedUrl = new URL(url);
    // Add any additional checks you need, e.g., trusted domains
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch (e) {
    return false;
  }
}

const downloadExcel = async (user_name: string, trialUuid: string) => {
  try {
    const res = await exportAsExcel({
      trial_uuid: trialUuid,
      user_email: user_name,
    });
    if (res) {
      if (res?.error?.includes("complete at least one")) {
        message.error(
          "Need to complete at least one soa table for exporting function"
        );
      } else if (res.presigned_url) {
        const url = DOMPurify.sanitize(res.presigned_url);
        const link = document.createElement("a");
        link.href = url;
        link.download = "filename.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } catch (error) {
    message.error("Failed to export");
  }
};

export const handleExportType = (
  evt: any,
  user_name: string,
  trialUuid: string
) => {
  const key = evt?.key;
  switch (key) {
    case "PDF":
      break;
    case "Excel":
      downloadExcel(user_name, trialUuid);
      break;
    case "Word Doc":
      break;
    default:
      break;
  }
};

export const exportOption: MenuItem[] = [
  // {
  //   label: "Word Doc",
  //   key: "Word Doc",
  // },
  // {
  //   label: "PDF",
  //   key: "PDF",
  // },
  {
    label: "Excel",
    key: "Excel",
  },
];
